// extracted by mini-css-extract-plugin
export var logo = "_ks-2";
export var logoWrapper = "_ks-1";
export var strip = "_ks-0";